import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import { AppHeader } from "@/components/AppHeader";
import { AppSidebar } from "@/components/AppSidebar";
import { MobileNav } from "@/components/MobileNav";

export function App() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="relative flex min-h-screen">
      <div aria-hidden="true" className="app-backdrop" />
      <AppSidebar />
      <MobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />
      <div className="relative z-10 flex min-w-0 flex-1 flex-col">
        <AppHeader onMenuOpen={() => setMobileNavOpen(true)} />
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
      <Toaster richColors position="top-right" closeButton />
    </div>
  );
}
